import { ComponentPropsWithoutRef, useMemo } from 'react';
import { IconMap, IconName } from './icons';
import { twMerge } from 'tailwind-merge';

interface NucleoIconProps extends ComponentPropsWithoutRef<'svg'> {
    size?: 'xs' | 'sm' | 'md' | 'lg';
    icon: IconName;
}

const NucleoIcon = ({ size = 'md', className = '', icon }: NucleoIconProps) => {
    const dimension = useMemo(() => {
        switch (size) {
            case 'xs':
                return 12;
            case 'sm':
                return 14;
            case 'md':
                return 18;
            case 'lg':
                return 24;
        }
    }, [size]);

    return (
        <svg
            fill="none"
            height={dimension}
            width={dimension}
            viewBox={`0 0 18 18`}
            xmlns="http://www.w3.org/2000/svg"
            className={twMerge('fill-current', className)}
        >
            {IconMap.get(icon)}
        </svg>
    );
};

export { NucleoIcon };
export type { NucleoIconProps };
